module.exports = __webpack_public_path__ + "static/kerry-a75febb1447b0e7aa554ec57c24b4cb8.jpg";